import { defineComponent as _defineComponent } from 'vue'
import { globalVar } from '@/helpers/globals';


export default /*#__PURE__*/_defineComponent({
  __name: 'FrontpageCard',
  props: {
    height: {
        type: [String, Number],
        default: null,
    },
},
  setup(__props) {



return { __sfc: true,globalVar }
}

})